var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusLastStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 32,
    viewBox: "0 0 133 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_589_30523",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.2623 6.54771C-0.892699 3.93934 0.962578 0 4.34601 0H129C131.209 0 133 1.79086 133 4V28C133 30.2091 131.209 32 129 32H4.346C0.962567 32 -0.8927 28.0607 1.2623 25.4523L6.96678 18.5477C8.18852 17.0689 8.18852 14.9311 6.96678 13.4523L1.2623 6.54771Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.2623 6.54771C-0.892699 3.93934 0.962578 0 4.34601 0H129C131.209 0 133 1.79086 133 4V28C133 30.2091 131.209 32 129 32H4.346C0.962567 32 -0.8927 28.0607 1.2623 25.4523L6.96678 18.5477C8.18852 17.0689 8.18852 14.9311 6.96678 13.4523L1.2623 6.54771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96678 18.5477L6.19586 17.9108H6.19586L6.96678 18.5477ZM6.96678 13.4523L6.19586 14.0892L6.96678 13.4523ZM1.2623 6.54771L0.491379 7.18464L1.2623 6.54771ZM129 -1H4.34601V1H129V-1ZM134 28V4H132V28H134ZM4.346 33H129V31H4.346V33ZM6.19586 17.9108L0.491378 24.8154L2.03322 26.0892L7.73771 19.1846L6.19586 17.9108ZM6.19586 14.0892C7.11217 15.1983 7.11216 16.8017 6.19586 17.9108L7.73771 19.1846C9.26488 17.3362 9.26488 14.6638 7.73771 12.8154L6.19586 14.0892ZM0.491379 7.18464L6.19586 14.0892L7.73771 12.8154L2.03323 5.91078L0.491379 7.18464ZM4.346 31C1.80842 31 0.416975 28.0455 2.03322 26.0892L0.491378 24.8154C-2.20238 28.0758 0.116711 33 4.346 33V31ZM132 28C132 29.6569 130.657 31 129 31V33C131.761 33 134 30.7614 134 28H132ZM4.34601 -1C0.116726 -1 -2.20238 3.92417 0.491379 7.18464L2.03323 5.91078C0.416979 3.95451 1.80843 1 4.34601 1V-1ZM129 1C130.657 1 132 2.34315 132 4H134C134 1.23858 131.761 -1 129 -1V1Z",
    fill: "#C1C9D2",
    mask: "url(#path-1-inside-1_589_30523)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusLastStep);
export default __webpack_public_path__ + "static/media/status-last-step.034479c0157f56c2746ddfd0674f6b26.svg";
export { ForwardRef as ReactComponent };